// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".form-attachment[data-v-30d7d4ff]:hover {\n  color: #ea5455 !important;\n}[dir] .form-attachment[data-v-30d7d4ff]:hover {\n  border-color: #ea5455 !important;\n}", ""]);
// Exports
module.exports = exports;
